import React from "react";

function EnterpriseSolutionHero() {
  return (
    <>
      <div
        className="banner-style-two-area bg-theme shadow theme text-light bg-cover"
        style={{
          background:
            "url(assets/img/bg/white_label_crypto_exchange_image.jpg)",
        }}
      >
        <div className="container">
          <div className="row align-center">
            <div className="col-xl-9 col-lg-8">
              <div className="banner-two-content">
                <h2 className="split-text-right split-text-in-right">
                  Enterprise Blockchain Solutions for Various Industries
                </h2>
                <div className="info">
                  <p className="fade-up-anim">
                    At Xeer Technology, we empower businesses across diverse
                    sectors by integrating blockchain technology, creating
                    tailored, secure, and efficient solutions that drive
                    innovation, enhance transparency, and optimize operations.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default EnterpriseSolutionHero;
